import Vue from 'vue'
import * as types from '../mutation-types'
import buildings from '../../api/buildings'
import organisations from "../../api/organisations";

var buildingTemplate = {
    address: "",
    commencementDate: "2000-01-01T00:00:00+00:00",
    completionDate: "2000-01-01T00:00:00+00:00",
    cover_image_url: "",
    createdAt: "2000-01-01T00:00:00+00:00",
    description: "",
    id: -1,
    lat: 0,
    long: 0,
    name: "",
    num_files: 0,
    updatedAt: "2018-08-12T03:53:37+00:00",
};

// state
export const state = {
    data: buildingTemplate,
    users: [],
}

// getters
export const getters = {}

// mutations
export const mutations = {
    [types.SET_BUILDING_DETAIL](state, {data, users}) {
        state.data = data;
        state.users = users;
    },
}

// actions
export const actions = {
    getBuildingDetail ({ commit }, buildingId) {
        buildings.getBuildingDetail(buildingId, (building, users) => {
            commit(types.SET_BUILDING_DETAIL, {data: building, users: users})
        })
    },

    updateBuilding({commit}, payload) {
        commit(types.SET_BUILDING_DETAIL, payload)
    },

    revokeAccess({commit}, payload) {
        buildings.revokeAccess(payload, (org, users) => {
            commit(types.SET_BUILDING_DETAIL, {data: org, users: users})
        })
    },

    updateAccess({commit}, {id, level}) {
        buildings.updateAccess(id, level, (org, users) => {
            commit(types.SET_BUILDING_DETAIL, {data: org, users: users})
        })
    },

    addAccess({commit}, {entityId, userId, level}) {
        buildings.grantAccess(entityId, userId, level, (org, users) => {
            commit(types.SET_BUILDING_DETAIL, {data: org, users: users})
        })
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/building.js